import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get, post } from '../../services/apiServices'
import { token } from '../../services/authServices'
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import {
    usersAction,
    classRoomsAction
} from '../../actions/contentActions'
import { StoryMode, ChallengeMode, Effort, ChallengeDetails } from '../content/ReportComponents'
import Tabs from 'material-ui/Tabs';
import { Tab } from 'material-ui/Tabs';
import Grid from "material-ui/Grid";


const styles = {
    classRoomSelect: {
        minWidth: '200px',
        marginLeft: '10px'
    },
    classRoomSelectMenu: {
        minWidth: '200px',
    },
};

export default class ReportStandaloneContainer extends Component {
    state = {
        classRooms: [],
        classRoomId: 0,
        selectedAccount: {},

    }

    componentDidMount() {
        const accountId = this.props.match.params ?
            this.props.match.params.id : false

        get(`/admin/accounts/by-org-id/${accountId}`, token).then(res => {
            let selectedAccount = res.data.data
            this.setState({ selectedAccount })

            if (selectedAccount.type === "school") {
                get(`/admin/accounts/${selectedAccount.id}/classes?all=true`, token).then(res => {
                    this.setState({ classRooms: res.data.data });
                })
            }
        })


    }
    handleClassChange = (event) => {
        this.setState({ classRoomId: event.target.value })
    }
    render() {
        const { classRooms, classRoomId, selectedAccount } = this.state
        const type = this.props.match.params ?
            this.props.match.params.type : 'story-mode'
        return selectedAccount && selectedAccount.id ? (
            <div>
                <div className="top-panel">
                    {selectedAccount.type === "school" && <div>
                        <InputLabel htmlFor="stage-select" style={{ marginLeft: '20px' }}>
                            Class
                        </InputLabel>
                        <Select
                            style={styles.classRoomSelect}
                            value={this.state.classRoomId}
                            onChange={this.handleClassChange}
                            autoWidth
                        >
                            <MenuItem value={0} style={styles.classRoomSelectMenu}>
                                Whole school
                                </MenuItem>
                            {classRooms && classRooms.map((item, index) => {
                                return (
                                    <MenuItem key={index} value={item.id} style={styles.classRoomSelectMenu}>
                                        {item.name}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </div>}
                </div>

                {type === 'story-mode' && <StoryMode
                    accountId={selectedAccount.id}
                    classRoomId={classRoomId}
                />}
                {type === 'challenge-mode' && <ChallengeMode
                    accountId={selectedAccount.id}
                    classRoomId={classRoomId}
                />}
                {type === 'effort' && <Effort
                    accountId={selectedAccount.id}
                    classRoomId={classRoomId}
                />}
                {type === 'challenge-details' && <ChallengeDetails
                    accountId={selectedAccount.id}
                    classRoomId={classRoomId}
                />}
            </div>
        ) : null
    }
}


// WEBPACK FOOTER //
// ./src/components/containers/ReportStandaloneContainer.js